import { useEffect } from "react";
import Layout from "@/components/site/Layout";
import PageHero from "@/components/site/PageHero";
import { Reveal } from "@/components/site/Reveal";
import ContactForm from "@/components/site/ContactForm";
import { MapPin, Phone, Mail } from "lucide-react";
import { useSite } from "@/context/SiteContext";

export default function Contact() {
  const { content } = useSite();
  const f = content?.footer || {};
  useEffect(() => { window.scrollTo(0, 0); document.title = "Contact | Labpronics Technologies"; }, []);
  return (
    <Layout>
      <PageHero eyebrow="Get in Touch" title="Talk to Our Integration Team" subtitle="Tell us about your surveillance, command & control, cybersecurity or smart-governance requirement. We respond promptly." image="/generated/hero_command.jpg" />
      <section className="py-20">
        <div className="container-lp grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <Reveal>
              <div className="space-y-5 text-lp-ink">
                <div className="flex gap-4"><MapPin className="text-lp-cyan shrink-0" /><p className="text-lp-muted">{f.address || "Forum Mart, Kharvela Nagar, Bhubaneswar, Odisha 751001"}</p></div>
                <div className="flex gap-4"><Phone className="text-lp-cyan shrink-0" /><p className="text-lp-muted">{f.phone || "+91 91786 77237"}</p></div>
                <div className="flex gap-4"><Mail className="text-lp-cyan shrink-0" /><p className="text-lp-muted">{f.email || "info@labpronicstech.com"}</p></div>
              </div>
            </Reveal>
            <Reveal delay={0.1}>
              <div className="mt-8 border border-lp-border rounded-sm overflow-hidden">
                <iframe title="Labpronics office location" src="https://www.google.com/maps?q=Kharvela%20Nagar%2C%20Bhubaneswar%2C%20Odisha%20751001&output=embed" className="w-full h-72 border-0" loading="lazy" />
              </div>
            </Reveal>
          </div>
          <div className="lg:col-span-7">
            <Reveal delay={0.1}><ContactForm /></Reveal>
          </div>
        </div>
      </section>
    </Layout>
  );
}
